export default __webpack_public_path__ + "static/media/placeholder.c15e122e.svg";